// French relative-ish date used for mail tooltips and mail rows (mirrors the
// harmon.ie look: "Aujourd'hui à 14:59" / "Hier à 14:59" / "12/07/2026 à 14:59").
export function formatMailDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === now.toDateString()) return `Aujourd'hui à ${time}`;
  if (d.toDateString() === yesterday.toDateString()) return `Hier à ${time}`;
  return `${d.toLocaleDateString('fr-FR')} à ${time}`;
}
